
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { RoomInformation } from '../dto/RoomInformation';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class RoomInformationService {
 
    apiServer = environment.apiHost + environment.apiPort;
    constructor( 
      public http: HttpClient 
    ) { }   
  
    LoadByRoomNumber(subscriber: string, hotelId: number, roomNumber: string) {
       return this.http.get(`${this.apiServer}/api/kip/Room/LoadRoomInfo/${subscriber}/${hotelId}/${roomNumber}`)
    }
  }